import React from "react";
import { BsFillExclamationCircleFill } from "react-icons/bs";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";
import { ModalStore } from "store/modalStore";

export const NotificationModal = ({ data, closeModal }: { data: ModalStore; closeModal: () => void }) => {
  if (!data.notification) return null;
  return (
    <Modal
      onClose={() => {
        data.notification?.cancelAction && data.notification.cancelAction();
        closeModal();
      }}
      isOpen={data.notification.modalState === "open"}
    >
      <div className="relative flex h-[250px] w-[400px] flex-col items-center px-8 pb-5">
        <div className="relative flex h-5/6 flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            {data.notification.isHiddenWarningIcon || (
              <BsFillExclamationCircleFill className="fill-warning text-[20px]" />
            )}
            <p className="ml-2 flex text-20px">{data.notification.notificationMessage}</p>
          </div>
          <p className="relative mt-4 text-center text-16px">{data.notification.subMessage}</p>
        </div>
        <div className="absolute bottom-5 flex justify-center gap-4">
          <div className="w-[160px]">
            <Button
              text={"キャンセル"}
              onClick={() => {
                data.notification?.cancelAction && data.notification.cancelAction();
                closeModal();
              }}
              style={ButtonStyle.OUTLINE}
            />
          </div>
          <div className="w-[160px]">
            <Button
              text={data.notification.positiveButtonText}
              onClick={data.notification.positiveAction}
              style={ButtonStyle.RED_OUTLINE}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

